import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { AccountingModelListComponent } from './accountingModel-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { AccountingModelService } from './accountingModel.service';

@Component({
    selector: 'convfact-accountingModelDelete',
    templateUrl: './accountingModel-dialog-delete.component.html',
    styleUrls: ['./accountingModel.component.css'],
    standalone: false
})

export class AccountingModelDialogDeleteComponent {
    uid: string = this.data.uid;
    type: string = this.data.type;
    error_msg: string;
    error = false;

    constructor(
        public dialogRef: MatDialogRef<AccountingModelListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public accountingModelService: AccountingModelService
    ) { }

    displayInfo(message: string): void {
        const options = new MatSnackBarConfig();
        options.duration = 10000;
        options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
    }

    delete() {
        this.accountingModelService.deleteData(this.uid)
            .then(response => {
                this.displayInfo(response);
                this.closeDialog();
            })
            .catch(error => {
                this.displayInfo(error);
                this.closeDialog();
            });
        this.error = true;
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
